import axios from "axios";

export const API_URL = (
  process.env.REACT_APP_API_URL || "/api"
).replace(/\/+$/, "");

const sessionKey = (company) => `netledger_pos:${company}`;

export function getPosSession(company) {
  if (!company) {
    return null;
  }

  try {
    const value = sessionStorage.getItem(sessionKey(company));

    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

export function savePosSession(company, data) {
  if (!company || !data?.access_token) {
    throw new Error("No fue posible guardar la sesión POS.");
  }

  sessionStorage.setItem(
    sessionKey(company),
    JSON.stringify(data)
  );
}

export function clearPosSession(company) {
  if (company) {
    sessionStorage.removeItem(sessionKey(company));
  }
}

export function getPosHeaders(company) {
  const token = getPosSession(company)?.access_token;

  return token
    ? { Authorization: `Bearer ${token}` }
    : {};
}

export const api = axios.create({
  baseURL: API_URL,
});